module.exports = __webpack_public_path__ + "img/bird-fly-1.b82a3608.png";